export default "__VITE_ASSET__73f73MGQ__";